import React from 'react';
import { ReferenceImageSlide } from './ReferenceImageSlide';
import type { SlideProps } from './SlideShell';
export function SlideReferenceCampaignCalendar(props: SlideProps) {
  return <div className="relative h-full w-full overflow-hidden bg-[var(--bg)]" data-id="element-156" data-mp="1iv5k7hd1csxy">
      <ReferenceImageSlide {...props} src="https://cdn.magicpatterns.com/uploads/mvwXHMKEmQpAmta5kxBQsX/Screenshot_2026-08-21_at_10.37.24.png" alt="A calendar, not a campaign-by-campaign ask" recolorOrange data-id="element-157" data-mp="1ix8jks02vyfc" />
      <div aria-hidden="true" className="absolute bottom-[5.2%] left-[6%] h-[5.8%] w-[48%] bg-[var(--bg)]" data-id="element-158" data-mp="1wtlrpaiq2nh5" />
    </div>;
}